import { createContext, useContext } from 'react';

/**
 * The DashboardLayout owns the TopBar; pages rendered through <Outlet/> can project
 * controls into it (e.g. the AI Chat's chat/cards view toggle next to the profile menu)
 * by reading this element and rendering into it with a portal.
 */
export const TopBarSlotContext = createContext<HTMLElement | null>(null);

export const useTopBarSlot = (): HTMLElement | null => useContext(TopBarSlotContext);
